import { render } from "./Snake.vue?vue&type=template&id=0cb0302f&scoped=true"
import script from "./Snake.vue?vue&type=script&lang=js"
export * from "./Snake.vue?vue&type=script&lang=js"

import "./Snake.vue?vue&type=style&index=0&id=0cb0302f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0cb0302f"

export default script